<!--
 * @Author: scg
 * @Date: 2022-01-06 21:29:46
 * @LastEditTime: 2022-03-15 18:42:27
 * @LastEditors: scg
 * @Description:
-->
<template>
  <div class="fff">
    <div class="apps_title">{{$t('applications.title')}}</div>
    <!-- <div class="apps_title">Basic</div> -->
    <div class="apps_ul">
      <div class="apps_li" style="display: flex;justify-content: space-between;" v-for="(val, key) in list" :key="key">
        <div :title="val.name" style="white-space: nowrap;text-overflow: ellipsis;-o-text-overflow: ellipsis;overflow: hidden;width: calc(100% - 62px);">
          <img v-if="val.icon" :src="'data:image/gif;base64,' + val.icon" />
          <img v-else src="@/assets/img/img.png" />
          {{ val.name }}
        </div>
        <div
          @click="addlist(val.id, val.is_block)"
          :class="val.is_block == 1 ? 'Block' : 'Block'"
        >
          {{ val.is_block == 1 ? $t("Block") : $t("Unblock") }}
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { App, AppAddBlock } from '@/api/user'
export default {
  name: 'HelloWorld',
  data () {
    return {
      key: {
        equipment_id: localStorage.getItem('systemId'),
        page: 1,
        limit: 9999
      },
      list: [],
      msg: ''
    }
  },
  mounted () {
    this.getlist()
  },
  methods: {
    getlist () {
      App(this.key).then((adj) => {
        this.list = adj.data.list
      })
    },
    addlist (a, b) {
      var key = {
        equipment_id: localStorage.getItem('systemId'),
        app_id: a,
        block: b === 1 ? b + 1 : 1
      }
      AppAddBlock(key).then((qwe) => {
        this.webUrl = ''
        this.getlist()
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fff {
  width: 97%;
  margin: 20px auto;
  background: #fff;
  border-radius: 12px;
  -webkit-box-shadow: 0 4px 12px -4px rgba(122, 138, 153, 0.2);
  box-shadow: 0 4px 12px -4px rgba(122, 138, 153, 0.2);
  overflow: hidden;
  padding-bottom: 60px;
}
.apps_title {
  line-height: 55px;
  padding-top: 10px;
  height: 55px;
  text-indent: 2.5%;
  font-size: 14px;
  color: #000927;
  font-weight: 700;
}
.apps_ul {
  overflow: hidden;
  width: 100%;
  margin-bottom: -20px;
}
.apps_li {
  float: left;
  width: 29%;
  margin-left: 2.5%;
  border: 1px solid #e1e3e6;
  border-radius: 12px;
  line-height: 68px;
  height: 68px;
  font-size: 14px;
  overflow: hidden;
  margin-bottom: 20px;
}
.apps_li img {
  display: block;
  width: 32px;
  height: 32px;
  float: left;
  margin: 18px 10px 0 16px;
}
.apps_li .Block {
  float: right;
  margin: 22px;
  cursor: pointer;
}
.apps_li .Block.mr {
  background: red;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Applications.vue